import { DateTime } from "luxon";
import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter, ActionFilter } from "../FilterTypes";
import DateFilterUI from "../ui/DateFilterUI.vue";
import DateFilterBadge from "../ui/badges/DateFilterBadge.vue";

export default class DateFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly date: [DateTime | null, DateTime | null],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = DateFilterBadge;

  static readonly UI = DateFilterUI;

  getEventFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_OCCURRENCE_DATE,
        value: {
          value: this.date.map((dt) => (dt ? dt.toISODate() : null)),
          negated: this.isNegated ?? false,
        },
      },
    };
  }

  getActionFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.ACTION_DEADLINE,
        value: {
          value: this.date.map((dt) => (dt ? dt.toISODate() : null)),
          negated: this.isNegated ?? false,
        },
      },
    };
  }

  serialize() {
    return {
      date: this.date.map((dt) => dt?.toISO() ?? "null"),
      isNegated: this.isNegated,
    };
  }

  static deserialize(values: { date: string[]; isNegated?: boolean }) {
    return new DateFilter(
      values.date.map((isoString) =>
        isoString === "null" ? null : DateTime.fromISO(isoString),
      ) as [DateTime | null, DateTime | null],
      values.isNegated,
    );
  }
}
